import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { filter, map, take, tap } from 'rxjs';
import { PushNotificationsDevicesFacade } from '../facades/push-notifications-devices.facade';

export function pushNotificationsDevicesLoaded(): CanActivateFn {
    return () => {
        const pushNotificationsDevicesFacade = inject(PushNotificationsDevicesFacade);

        return pushNotificationsDevicesFacade.loaded$.pipe(
            tap((loaded) => {
                if (loaded === null) {
                    pushNotificationsDevicesFacade.getDevices();
                }
            }),
            filter((loaded) => loaded !== null),
            take(1),
            map(() => true),
        );
    };
}
